import React, { useEffect, useState } from "react";
import {
  Modal,
  Input,
  DatePicker,
  Select,
  Button,
  message,
  Pagination,
  Spin,
  Empty,
  Drawer,
} from "antd";
import dayjs from "dayjs";
import { API_BASE_CRM_URL } from "../../Config/Config";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
const { Search } = Input;
export default function Reminders({ customerId, relType }) {
  const navigate = useNavigate();
  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (!userDetails) {
      navigate("/");
    }
  }, [navigate]);
  const [remindersData, setRemindersData] = useState([]);
  const [staffDropdownData, setStaffDropdownData] = useState([]);
  const [remindersLoading, setRemindersLoading] = useState(false);

  const [selectedStaffId, setSelectedStaffId] = useState(null);

  useEffect(() => {
    const storedUser = sessionStorage.getItem("userDetails");

    if (storedUser) {
      const userDetails = JSON.parse(storedUser);

      setSelectedStaffId(userDetails?.staffid || null);
    }
  }, []);

  const [remindersSearchText, setRemindersSearchText] = useState("");

  const [remindersCurrentPage, setRemindersCurrentPage] = useState(1);

  const remindersPageSize = 6;

  const [addReminderModalOpen, setAddReminderModalOpen] = useState(false);

  const [addReminderLoading, setAddReminderLoading] = useState(false);

  const [addReminderData, setAddReminderData] = useState({
    description: "",
    date: null,
    staff: selectedStaffId,
  });

  const [editReminderModalOpen, setEditReminderModalOpen] = useState(false);

  const [editReminderLoading, setEditReminderLoading] = useState(false);

  const [editReminderData, setEditReminderData] = useState({
    id: "",
    description: "",
    date: null,
    staff: selectedStaffId,
  });

  const fetchStaffDropdown = async () => {
    try {
      const response = await fetch(`${API_BASE_CRM_URL}staff/GetStaffDropdown`);

      const data = await response.json();

      if (data.Status) {
        setStaffDropdownData(data.ResultData || []);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchReminders = async () => {
    try {
      setRemindersLoading(true);

      const response = await fetch(
        `${API_BASE_CRM_URL}reminder/GetReminders?rel_id=${customerId}&rel_type=${relType}&staffid=0`,
      );

      const data = await response.json();

      if (data.Status) {
        setRemindersData(data.ResultData || []);
      } else {
        setRemindersData([]);
      }
    } catch (error) {
      console.error(error);
      setRemindersData([]);
    } finally {
      setRemindersLoading(false);
    }
  };

  useEffect(() => {
    fetchStaffDropdown();
  }, []);

  useEffect(() => {
    if (customerId && selectedStaffId) {
      fetchReminders();
    }
  }, [customerId, selectedStaffId]);

  const filteredReminders = remindersData.filter(
    (reminder) =>
      reminder.description
        ?.toLowerCase()
        .includes(remindersSearchText.toLowerCase()) ||
      `${reminder.firstname} ${reminder.lastname}`
        .toLowerCase()
        .includes(remindersSearchText.toLowerCase()),
  );

  const startIndex = (remindersCurrentPage - 1) * remindersPageSize;

  const paginatedReminders = filteredReminders.slice(
    startIndex,
    startIndex + remindersPageSize,
  );

  const handleAddReminder = async () => {
    try {
      setAddReminderLoading(true);

      const payload = {
        description: addReminderData.description,
        date: dayjs(addReminderData.date).format("YYYY-MM-DD HH:mm:ss"),
        rel_id: customerId,
        rel_type: "Customer",
        staff: addReminderData.staff,
        creator: selectedStaffId,
      };

      const response = await fetch(`${API_BASE_CRM_URL}reminder/AddReminder`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (data.Status) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 2000,
          showConfirmButton: false,
        });

        setAddReminderModalOpen(false);

        fetchReminders();

        setAddReminderData({
          description: "",
          date: null,
          staff: selectedStaffId,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.Message || "Failed to add reminder",
        });
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to add reminder",
      });
    } finally {
      setAddReminderLoading(false);
    }
  };

  const handleUpdateReminder = async () => {
    try {
      setEditReminderLoading(true);

      const payload = {
        id: editReminderData.id,
        description: editReminderData.description,
        date: dayjs(editReminderData.date).format("YYYY-MM-DD HH:mm:ss"),
        staff: editReminderData.staff,
      };

      const response = await fetch(
        `${API_BASE_CRM_URL}reminder/UpdateReminder`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      if (data.Status) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 2000,
          showConfirmButton: false,
        });

        setEditReminderModalOpen(false);
        fetchReminders();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.Message || "Failed to update reminder",
        });
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update reminder",
      });
    } finally {
      setEditReminderLoading(false);
    }
  };

  if (remindersLoading) {
    return (
      <div className="text-center py-5">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <>
      <div className="row">
        <div className="col-12 d-flex align-items-center justify-content-between mb-3">
          <Search
            placeholder="Search reminders..."
            allowClear
            onChange={(e) => {
              setRemindersSearchText(e.target.value);
              setRemindersCurrentPage(1);
            }}
          />

          {/* <Select
            value={selectedStaffId}
            style={{ width: 250 }}
            onChange={(value) => setSelectedStaffId(value)}
            options={staffDropdownData.map((staff) => ({
              value: staff.staffid,
              label: `${staff.firstname} ${staff.lastname}`,
            }))}
          /> */}
          <button
            className="btn btn-sm btn-primary ms-2 mt-1"
            onClick={() => setAddReminderModalOpen(true)}
          >
            <i className="fa fa-solid fa-plus"></i>
          </button>
        </div>
      </div>
      {!paginatedReminders?.length && (
        <Empty description="No Reminders Found" />
      )}
      <div className="row">
        {paginatedReminders.map((reminder) => (
          <div className="col-12 col-md-6 col-lg-4 " key={reminder.id}>
            <div className="card shadow-sm border-0">
              <div className="card-body py-2">
                <div className="d-flex justify-content-between align-items-start">
                  <div className="flex-grow-1">
                    <div className="fw-semibold text-truncate">
                      <i className="fas fa-bell text-warning me-2"></i>
                      {reminder.description}
                    </div>

                    <div className="mt-1">
                      <small className="text-muted me-3">
                        <i className="fas fa-user me-1"></i>
                        {reminder.firstname} {reminder.lastname}
                      </small>

                      <small className="text-muted">
                        <i className="fas fa-calendar me-1"></i>
                        {dayjs(reminder.date).format("DD MMM YYYY")}
                      </small>
                    </div>
                  </div>

                  <i
                    className="fas fa-pen-to-square ms-2"
                    style={{
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                    onClick={() => {
                      setEditReminderData({
                        id: reminder.id,
                        description: reminder.description,
                        date: dayjs(reminder.date),
                        staff: reminder.staff,
                      });

                      setEditReminderModalOpen(true);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      {filteredReminders.length > remindersPageSize && (
        <Pagination
          className="mt-3 text-center"
          current={remindersCurrentPage}
          pageSize={remindersPageSize}
          total={filteredReminders.length}
          showSizeChanger={false}
          onChange={(page) => setRemindersCurrentPage(page)}
        />
      )}

      <Drawer
        open={addReminderModalOpen}
        closeIcon={false}
        title={
          <>
            <i className="fas fa-bell me-2 text-warning"></i>
            Add Follow-Up
          </>
        }
        placement="bottom"
        height="50vh"
        destroyOnClose
        onClose={() => setAddReminderModalOpen(false)}
        extra={
          <div className="d-flex gap-2">
            <div
              onClick={() => setAddReminderModalOpen(false)}
              style={{
                width: "38px",
                height: "38px",
                background: "#fff",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
              }}
            >
              <i
                className="fa-solid fa-xmark"
                style={{
                  color: "#dc3545",
                  fontSize: "16px",
                }}
              />
            </div>

            <div
              onClick={handleAddReminder}
              loading={addReminderLoading}
              style={{
                width: "38px",
                height: "38px",
                background: "#fff",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
              }}
            >
              <i
                className="fa-solid fa-check"
                style={{
                  color: "#198754",
                  fontSize: "16px",
                }}
              />
            </div>
          </div>
        }
      >
        <div className="row g-3">
          <div className="col-12">
            <Input.TextArea
              rows={4}
              placeholder="Enter reminder description"
              value={addReminderData.description}
              onChange={(e) =>
                setAddReminderData((prev) => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
            />
          </div>

          <div className="col-md-6">
            <DatePicker
              showTime
              size="large"
              className="w-100"
              placeholder="Select Reminder Date"
              value={addReminderData.date}
              onChange={(value) =>
                setAddReminderData((prev) => ({
                  ...prev,
                  date: value,
                }))
              }
            />
          </div>

          <div className="col-md-6">
            <Select
              size="large"
              className="w-100"
              placeholder="Select Staff"
              value={addReminderData.staff}
              options={staffDropdownData.map((staff) => ({
                value: staff.staffid,
                label: `${staff.firstname} ${staff.lastname}`,
              }))}
              onChange={(value) =>
                setAddReminderData((prev) => ({
                  ...prev,
                  staff: value,
                }))
              }
            />
          </div>
        </div>

        {/* <div className="d-flex justify-content-end mt-4">
          <Button
            type="primary"
            loading={addReminderLoading}
            onClick={handleAddReminder}
          >
            Add Follow-Up
          </Button>
        </div> */}
      </Drawer>

      <Drawer
        open={editReminderModalOpen}
        closeIcon={false}
        title={
          <>
            <i className="fas fa-pen-to-square me-2 text-primary"></i>
            Edit Follow-Up
          </>
        }
        placement="bottom"
        height="50vh"
        destroyOnClose
        onClose={() => setEditReminderModalOpen(false)}
        extra={
          <div className="d-flex gap-2">
            <div
              onClick={() => setEditReminderModalOpen(false)}
              style={{
                width: "38px",
                height: "38px",
                background: "#fff",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
              }}
            >
              <i
                className="fa-solid fa-xmark"
                style={{
                  color: "#dc3545",
                  fontSize: "16px",
                }}
              />
            </div>

            <div
              onClick={handleUpdateReminder}
              loading={editReminderLoading}
              style={{
                width: "38px",
                height: "38px",
                background: "#fff",
                borderRadius: "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
              }}
            >
              <i
                className="fa-solid fa-check"
                style={{
                  color: "#198754",
                  fontSize: "16px",
                }}
              />
            </div>
          </div>
        }
      >
        <div className="row g-3">
          <div className="col-12">
            <Input.TextArea
              rows={4}
              placeholder="Enter reminder description"
              value={editReminderData.description}
              onChange={(e) =>
                setEditReminderData((prev) => ({
                  ...prev,
                  description: e.target.value,
                }))
              }
            />
          </div>

          <div className="col-md-6">
            <DatePicker
              showTime
              size="large"
              className="w-100"
              value={editReminderData.date}
              onChange={(value) =>
                setEditReminderData((prev) => ({
                  ...prev,
                  date: value,
                }))
              }
            />
          </div>

          <div className="col-md-6">
            <Select
              size="large"
              className="w-100"
              value={editReminderData.staff}
              options={staffDropdownData.map((staff) => ({
                value: staff.staffid,
                label: `${staff.firstname} ${staff.lastname}`,
              }))}
              onChange={(value) =>
                setEditReminderData((prev) => ({
                  ...prev,
                  staff: value,
                }))
              }
            />
          </div>
        </div>

        {/* <div className="d-flex justify-content-end mt-4">
          <Button
            type="primary"
            loading={editReminderLoading}
            onClick={handleUpdateReminder}
          >
            Update
          </Button>
        </div> */}
      </Drawer>
    </>
  );
}
